/***
 * NOTE: This is used for pages that are only disabled/protected on the front-end side and this component avoids
 * rendering children and triggering any api calls to the backend. In most cases <LoadingView /> is enough as
 * backend rejects the api call and it renders relevant error info.
 ***/
import React from "react";

import { Spinner } from "src/base-components/Spinner";
import { useCapabilities } from "src/hooks/useCapabilities";
import { Capabilities } from "src/hooks/useCapabilities/types";
import { ErrorPage } from "src/router/ErrorPage";

type Props = {
  children: React.ReactNode;
  canAccess: (capabilities: Capabilities) => boolean;
};

export const ProtectedPage: React.FC<Props> = ({ children, canAccess }) => {
  const capabilities = useCapabilities();

  if (capabilities.isLoading) {
    return <Spinner />;
  }

  if (canAccess(capabilities)) {
    return <>{children}</>;
  }

  return <ErrorPage message="You're not authorized to view this page." />;
};
